export default "__VITE_ASSET__BGsf9z4m__"